<template>
<div>
	<p v-if="!activeComponentIsBid"><a href="#" v-on:click.prevent="backToCats"><i class="fa fa-arrow-up"></i> Back</a></p>

	<ul class="list-group mb-2">
		<li v-for="component in componentsList"
			class="list-group-item list-group-item-action" 
			v-on:click="componentClicked(component)">

			{{ component.item_number }}: {{ component.name }}
		</li>
	</ul>
</div>
</template>
<script type="text/javascript">

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "BidComponentPicker",
	mixins: [ProjectBidMixins],
	props: [
		"bidId",
		"projectId",
		"depth"
	],
	data() {
		return {
			bid: null,
			activeComponent: null,
			activeComponentIsBid: false,
			componentsList: []
		}
	},
	watch: {
		bidId() {
			this.setBid()
		},
		projectId() {
			this.setBid()
		}
	},
	methods: {
		backToCats() {
			this.activeComponent = this.bid
			this.setComponentListFromBid()
		},
		componentClicked(component) {
			if (this.depth == 0 && this.activeComponentIsBid) {
				this.$emit('componentSelected',component)
			}
			else if (this.activeComponentIsBid) {
				this.fetchBidComponent(component.id)
			}
			else {
				this.backToCats()
				this.$emit("componentSelected",component)
			}
		},
		fetchBidComponent(id) {
			let vm = this

			let params = {
				include: ["JobBidComponent"]
			}

			vm.spinner(true)

			this.getJSON("JobBidComponent/find/"+id,params).then(response => {
				if (response.success) {
					vm.activeComponent = response.data
					vm.activeComponentIsBid = false
					vm.componentsList = vm.activeComponent.JobBidComponent
				}

				vm.spinner(false)
			})
		},
		setComponentListFromBid() {
			this.activeComponentIsBid = true
			this.componentsList = this.bid.JobBidComponent.filter(comp => comp.bid_component_id == 0)
		},
		setBid() {
			let options = {},vm = this
			if (this.projectId)
				options.projectId = this.projectId
			else if (this.bidId)
				options.bidId = this.bidId

			this.fetchActiveBid(options).then(response => {
				if (response) {
					vm.bid = response
					vm.activeComponent = response
					vm.setComponentListFromBid()
					vm.$emit("bidSet",vm.bid)
				}
			})
		}
	},
	created() {
		this.setBid()
	}
}
</script>